import firebase from 'firebase/app';
import 'firebase/app';
import 'firebase/database';
import 'firebase/messaging';

export const initializeFirebase = () => {
  // Initialize Firebase
  var config = {
    apiKey: 'AIzaSyAftgLgO45XNPQyB73Dg2ary8QUG1-91Qo',
    authDomain: 'go-ayutthaya-c3b7c.firebaseapp.com',
    databaseURL: 'https://go-ayutthaya-c3b7c.firebaseio.com',
    projectId: 'go-ayutthaya-c3b7c',
    storageBucket: 'go-ayutthaya-c3b7c.appspot.com',
    messagingSenderId: '538048394442'
  };
  firebase.initializeApp(config);

  // use other service worker
  // navigator.serviceWorker
  //   .register('/my-sw.js')
  //   .then((registration) => {
  //     firebase.messaging().useServiceWorker(registration);
  //   });
}

export const askForPermissioToReceiveNotifications = async () => {
  try {
    const database = firebase.database();
    const messaging = firebase.messaging();
    await messaging.requestPermission();
    const token = await messaging.getToken();
    console.log('user token: ', token);
    database.ref('/tokens').push({
      'token': token
    });
    return token;
  } catch (error) {
    console.error(error);
  }
}


// WEBPACK FOOTER //
// ./src/push-notification.js